<script lang="ts">
    import BookmarkButton from '$components/Bookmark/BookmarkButton.svelte';
    import ReactionButton from '$components/Reaction/ReactionButton.svelte';
    import ReactionCounter from '$components/Reaction/ReactionCounter.svelte';
    import { useFragment } from '$gql/fragment-masking.js';
    import {
        BookmarkItemFragmentDoc,
        type NewsFeedPostFragment,
        ReactionFragmentDoc,
    } from '$gql/graphql.js';
    import { cx } from '$lib/utils/cx.js';
    import FeedPostCommentWidget from './FeedPostCommentWidget.svelte';
    import FeedPostShareButton from './FeedPostShareButton.svelte';
    import type { CommentData } from './Utils';
    import ReactionsListModal, {
        createModal,
    } from '$components/Reaction/ReactionsListModal.svelte';
    import * as t from '$trans';
    import { getContainer } from '$components/Context/ContainerContext';

    const { currentUserStore, lang } = getContainer();

    export let post: NewsFeedPostFragment;
    export let commentData: CommentData | null = null;

    $: currentUser = currentUserStore().currentUser();

    let showCommentWidget = commentData != null;

    const reactionsModal = createModal({ defaultOpen: false });

    let reactionsCounters = post.reactionsCounters;

    $: bookmarkItem = useFragment(BookmarkItemFragmentDoc, post.bookmarkItem);
    $: reaction = useFragment(ReactionFragmentDoc, post.reaction);
</script>

<div>
    <div
        class={'flex items-center justify-between text-sm border-solid border-0 border-b border-gray-300 py-2 mb-2'}
    >
        <div class={'text-gray-800 hover:underline hover:text-link-hover cursor-pointer'}>
            {#if reactionsCounters.length > 0}
                <ReactionCounter
                    counters={reactionsCounters}
                    on:click={() => reactionsModal.states.open.set(true)}
                />
            {/if}
        </div>
        <button
            on:click|preventDefault={() => (showCommentWidget = !showCommentWidget)}
            class={'btn-reset text-gray-800 hover:underline hover:text-link-hover cursor-pointer'}
        >
            {#if post.commentsCount > 0}
                {t.feed_post.x_comments({ nb: post.commentsCount }, $lang)}
            {/if}
        </button>
    </div>
    <div class={'flex items-center justify-between'}>
        <!--  {secure( -->
        <ReactionButton
            {reaction}
            target={{ feedPostId: post.id }}
            author={{ userId: $currentUser?.id }}
            onReactionsCounters={(counters) => {
                reactionsCounters = counters;
            }}
        />
        <!--  )} -->

        <button
            on:click|preventDefault={() => {
                if (!showCommentWidget) {
                    //setTimeout(focusCommentInput, 100);
                }
                showCommentWidget = !showCommentWidget;
            }}
            type={'button'}
            class={cx(
                'bg-transparent border-none hover:bg-gray-200 cursor-pointer py-[12px] px-[14px] text-black rounded-full focus:outline-none focus:ring-2 focus:ring-brand-blue inline-flex items-center',
            )}
        >
            <i class={'fa-lg fa fa-commenting mr-2'} />
            <span class={'hidden ls:inline'}>
                {t.feed_post.button_to_comment({}, $lang)}
            </span>
        </button>
        <BookmarkButton
            {bookmarkItem}
            className={cx(
                'bg-transparent border-none hover:bg-gray-200 cursor-pointer py-[12px] px-[14px] text-black rounded-full focus:outline-none focus:ring-2 focus:ring-brand-blue inline-flex items-center',
            )}
            target={{ feedPostId: post.id }}
            checkedClassName={'text-brand-blue'}
            uncheckedClassName={'text-black'}
        >
            <i class={'fa-lg fa fa-bookmark mr-2'} />{' '}
            <span class={'hidden ls:inline'}>
                {t.feed_post.button_favorites({}, $lang)}
            </span>
        </BookmarkButton>
        <FeedPostShareButton {post} />
    </div>

    {#if showCommentWidget}
        <FeedPostCommentWidget {post} {commentData} />
    {/if}

    <ReactionsListModal
        modal={reactionsModal}
        counters={post.reactionsCounters}
        target={{ feedPostId: post.id }}
    />
</div>
